import http from "@/utils/request.js"

// 获取项目流程详情数据
export const getProjectProcessDetail = (params) => {
  return http.request({
    url: "/project-process/detail",
    method: "POST",
    data: params
  })
}

// 流程节点查看详情表单
export const flowTaskFormDetail =(processInsId, taskId)=> {
  return http.request({
    url: '/flowable/task/detail/' + processInsId + '/' + taskId,
    method: 'get',
  })
}

// 提交审批任务
export const submitFlowTask = (data) => {
  return http.request({
    url: '/flowable/task/complete',
    method: 'POST',
    data: data
  })
}



export const getProjectProcessDetailTaskList = (params) => {
  return http.request({
    url: "/project-process/detail/task/list",
    method: "GET",
    params: params
  })
}

// 获取任务是否需要审核
export const checkTaskAuditStatus = (params) => {
  return http.request({
    url: '/project-process/detail/task/is/auditing',
    method: 'get',
    params: params
  })
}
export const taskSupervise = (data) => {
  return http.request({
    url: '/project-process/detail/task/supervise',
    method: 'post',
    data: data
  })
}

// 获取流程图 XML 和节点状态
export const getFlowDiagramInfo = (params) => {
  return http.request({
    url: "/flowable/definition/flowXmlAndNode",
    method: "GET",
    params: params
  })
}

// 获取项目流程日志
export const getProcessLogs = (params) => {
  return http.request({
    url: "/flowLog/flowLog/list",
    method: "GET",
    params: params
  })
}

// 获取项目流程关系表分页
export const getProjectProcess = (data) => {
  return http.request({
    url: "/project-process/page",
    method: "POST",
    data: data
  })
}